import { useBlockEnvironment } from '@zillow/cms-blocks';
import { ConstructionLayout as ConstructionLayoutComponent } from '@zillow/zrs-cms';
import { useRouter } from 'next/router';
import React from 'react';

import GlobalStyle from '../GlobalStyle';
import LayoutHead from '../LayoutHead';
import OptimizelyScripts from '../OptimizelyScripts';
import { PreviewModeAlert } from '../PreviewModeAlert';

type SubnavItem = {
    id: string;
    title: {
        rendered: string;
    };
    url: string;
    parent: number;
};

export type NewConstructionLayoutProps = {
    children: React.ReactNode;
    head: string;
    preview?: boolean;
    submenu?: {
        items: SubnavItem[];
        meta: {
            title: string;
            url: string;
            search: string;
        };
    };
    isBlog?: boolean;
    header?: { disabled?: boolean; transparent?: boolean };
};

const NewConstructionLayout: React.FC<NewConstructionLayoutProps> = ({
    children,
    head,
    preview,
    submenu,
    header,
}) => {
    const { environment = 'prod' } = useBlockEnvironment();
    const router = useRouter();
    return (
        <>
            <LayoutHead
                head={head}
                preview={preview}
                defaultTitle="Zillow New Construction"
            />
            <ConstructionLayoutComponent
                router={router}
                environment={environment}
                submenu={submenu}
                header={header}
            >
                <GlobalStyle />
                <OptimizelyScripts />
                {children}
                {preview && <PreviewModeAlert />}
            </ConstructionLayoutComponent>
        </>
    );
};

export default NewConstructionLayout;
